import React from 'react';

import { usePageTitle } from '../../utils/hooks/usePageTitle';
import { useMetaTags } from '../../utils/hooks/useMetaTags';
import PageTitleLayout from '../../uiKit/pageTitleLayout';
import { useTranslation } from 'react-i18next';
import ReferralForm from '../forms/referralForm';
import Title from '../../uiKit/typography/title';
import Paragraph from '../../uiKit/typography/paragraph';
// todo: add text to localization file
export default function ReferralPage() {
  const { t } = useTranslation('common');

  return (
    <>
      <div className={'w-full bg-black flex flex-col items-center'}>
        <PageTitleLayout title={'Referral Program'}
                         className={'w-full flex flex-col items-center gap-8 pt-10 pb-32 px-4 mt-24 md:mt-48 max-w-7xl'}
                         classNameTitle={'md:!text-8xl'}>
        </PageTitleLayout>
      </div>

      <div
        className={'w-full flex flex-col gap-12 max-w-4xl py-32 px-4 md:px-16 [&_ol]:!list-decimal [&_ol]:p-[revert] [&_ul]:p-[revert] [&_ul]:!list-disc'}>
        <div className={'flex flex-col gap-6 [&>div]:flex [&>div]:flex-col [&>div]:gap-2 [&_li]:text-lg [&_li]:leading-7 [&_li]:text-gray'}>
          <Paragraph>
            Do you know someone who might be interested in joining Onlyplay?
            Refer a friend or colleague – and receive a referral bonus 💰
            <br/>
            <br/>
            Our team already includes 85+ specialists, and we continue to grow. We are constantly looking for strong professionals in IT and other fields.
            Perhaps among your contacts there is someone who could become part of our team?
          </Paragraph>

          <div>
            <Title className={'!text-3xl !text-left'}>
              What is a referral?
            </Title>
            <Paragraph>
              A referral is a recommendation of a candidate who, in your opinion, may be relevant for an open or future position at Onlyplay.
            </Paragraph>
          </div>

          <div>
            <Title className={'!text-3xl !text-left'}>
              How does it work?
            </Title>
            <ol>
              <li>Fill out a short form</li>
              <li>The candidate goes through the selection process</li>
              <li>After successfully completing the probation period, you receive a bonus</li>
            </ol>

            <Title className={'!text-xl !text-left'}>
              To make your referral valid:
            </Title>

            <ul>
              <li>We must receive the candidate’s contact details or CV directly from you</li>
              <li>The candidate must know that you are referring them</li>
              <li>The candidate must be open to new opportunities</li>
              <li>The referral is valid for 6 months from the submission date</li>
            </ul>

            <Paragraph className={''}>
              During communication, the recruiter will definitely inform the candidate that you referred them
            </Paragraph>
          </div>

          <div>
            <Title className={'!text-3xl !text-left'}>
              Bonus amount:
            </Title>

            <ul>
              <li>Junior - $100</li>
              <li>Junior+ / Pre-Middle – $150</li>
              <li>Middle – $300</li>
              <li>Senior – $500</li>
              <li>Team Lead – $1000</li>
              <li>C-level – $1500</li>
            </ul>

            <Paragraph>
              📌 The specialist level is determined by the company at the offer stage and may differ from the referrer’s initial assessment.
            </Paragraph>
          </div>

          <div>
            <Title className={'!text-3xl !text-left'}>
              Payment terms:
            </Title>
            <Paragraph>
              The bonus is paid after the candidate successfully completes the probation period (3 months).
            </Paragraph>

            <Title className={'!text-xl !text-left'}>
              The bonus is not paid if:
            </Title>

            <ul>
              <li>The candidate is already in our database</li>
              <li>The candidate has previously applied independently</li>
              <li>The candidate leaves before completing the probation period</li>
              <li>The offer was withdrawn</li>
            </ul>
          </div>

          <div>
            <Title className={'!text-3xl !text-left'}>
              Referral validity period
            </Title>
            <Paragraph>
              Your referral is valid for 6 months from the date of submission.
              <br/>
              <br/>
              If after this period the candidate is referred by someone else – it will be considered a new referral.
            </Paragraph>
          </div>

        </div>

        <ReferralForm />
      </div>
    </>
  );
}
